import {NgModule} from '@angular/core';
import {LoginAuthService} from './services/login-auth.service';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class LoginAuthModule {
  public static forRoot() {
    return {
      ngModule: LoginAuthModule,
      providers: [LoginAuthService]
    };
  }
}
